import {reactive} from "vue";


class GrupoPermissaoEvent {



    listenerGrupoGravado = reactive({value: {codigo: 0}})

    emitGrupoGravado(codigo: number) {
        this.listenerGrupoGravado.value = {codigo: codigo}
    }


}

export default GrupoPermissaoEvent;